module.exports = __webpack_public_path__ + "static/media/carroussel_20.efee0b03.jpg";